import { render, staticRenderFns } from "./StartProxy.vue?vue&type=template&id=77f61431&scoped=true"
import script from "./StartProxy.vue?vue&type=script&lang=js"
export * from "./StartProxy.vue?vue&type=script&lang=js"
import style0 from "./StartProxy.vue?vue&type=style&index=0&id=77f61431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f61431",
  null
  
)

export default component.exports